import { FieldError, Merge, FieldErrorsImpl } from "react-hook-form";

export function extractFormErrorMessage(
  error?: FieldError | string | Merge<FieldError, FieldErrorsImpl<any>>,
): string | undefined {
  if (!error) return undefined;

  if (typeof error === "string") {
    return error;
  }

  if (error.message) {
    return extractFormErrorMessage(error.message);
  }

  if (error.types) {
    const firstType = Object.keys(error.types)[0];
    return error.types[firstType].message || "";
  }

  return "Unknown error";
}
